import { GoogleCloudStorageStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/google-cloud-storage-store-read-settings';
import { Metamodel, SapDatasphereForGoogleCloudStorageLinkedService } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapDatasphereForGoogleCloudStorage.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(SapDatasphereForGoogleCloudStorageLinkedService)
    }
})
export class SapDatasphereForGoogleCloudStorageReadSettings extends GoogleCloudStorageStoreReadSettings {}
